/**
 * Helper function to convert a regular URL to a Kratos URL by prefixing with /kratos
 * @param url - The original URL to convert
 * @returns The Kratos-prefixed URL
 */
export function toKratosUrl(url: string): string {
  return `/kratos${url}`;
}
